export enum CustomerType {
  Individual = 1,
  Corporate = 2,
}
